function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M50 5a45 45 0 1045 45A45.05 45.05 0 0050 5zm0 82a37 37 0 1137-37 37.041 37.041 0 01-37 37zm-5-62a5 5 0 115 5 5 5 0 01-5-5zm16 46v4a2 2 0 01-2 2H41a2 2 0 01-2-2v-4a2 2 0 012-2h2a2 2 0 002-2V48a2 2 0 00-2-2h-2a2 2 0 01-2-2v-4a2 2 0 012-2h12a2 2 0 012 2v27a2 2 0 002 2h2a2 2 0 012 2z"
});

function SvgAbout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 100 125"
  }, props), _ref);
}

export default SvgAbout;